import { EstimatorMarkerOverlay } from './EstimatorMarkerOverlay';

export class MarketInsightsOverlay extends EstimatorMarkerOverlay {}
